import config from "../../utils/globalConfig";

export const endpointConstants = {
  AUTH:
    config.YODA_BACKEND + "/Identity/api/v1/Authentication/" + config.TENANT_ID,
  REFRESHTOKEN:
    config.YODA_BACKEND +
    "/Identity/api/v1/Authentication/:refreshtoken/refresh",
  YODACATALOGUE: {
    GET_ONE:
      config.YODA_BACKEND +
      "/catalog/api/v1/CommandAction/execute/B2BCatalog?customerId=:customerId&productId=:productId&seasonId=:seasonId",
    GET_ONE_SWAP:
      config.YODA_BACKEND +
      "/catalog/api/v1/CommandAction/execute/B2BCatalogSwapDetail?customerId=:customerId&productId=:productId&seasonId=:seasonId",
    GET_ALL:
      config.YODA_BACKEND +
      "/catalog/api/v1/CommandAction/execute/B2BCatalogList2?searchText=:searchText&seasonId=:seasonId&lineId=:lineId&customerId=:customerId&page=:page&pageSize=:pageSize",
    GET_ALL_SWAP:
      config.YODA_BACKEND +
      "/catalog/api/v1/CommandAction/execute/B2BCatalogSwap2?searchText=:searchText&seasonId=:seasonId&lineId=:lineId&customerId=:customerId&page=:page&pageSize=:pageSize",
    GET_FILTERS:
      config.YODA_BACKEND +
      "/catalog/api/v1/CommandAction/execute/B2BCatalogFilter2?customerId=:customerId&seasonId=:seasonId&lineId=:lineId",
    GET_FILTERS_SWAP:
      config.YODA_BACKEND +
      "/catalog/api/v1/CommandAction/execute/B2BCatalogSwapFilter?customerId=:customerId&seasonId=:seasonId&lineId=:lineId",
    GET_ONE_CATALOG: config.YODA_BACKEND + "/catalog/api/v1/Catalog/:catalogId",
    SEND_LOG:
      config.YODA_BACKEND +
      "/catalog/api/v1/CommandAction/Execute/B2BLogFEPost",
    MAINTENANCE:
      config.YODA_BACKEND +
      "/catalog/api/v1/CommandAction/Execute/B2BIsInMaintenance",
  },
  YODAORDERS: {
    GET_ALL_HEADERS:
      config.YODA_BACKEND +
      "/order/api/v1/CommandAction/execute/B2BOrderHeaders?page=:page&pageSize=:pageSize&id=:customerId&Filters",
    GET_ALL:
      config.YODA_BACKEND +
      "/order/api/v1/CommandAction/execute/B2BOrders?customerId=:customerId&agentId=:agentId&page=1&pageSize=100&Filters",
    GET_ONE: config.YODA_BACKEND + "/order/api/v1/Orders/:id",
    CREATE_HEADER: config.YODA_BACKEND + "/order/api/v1/Orders",
    ADD_ROW: config.YODA_BACKEND + "/order/api/v1/Orders/:orderId/rows", // post
    UPDATE_ROW:
      config.YODA_BACKEND + "/order/api/v1/Orders/:orderId/rows/:rowId", // put
    REMOVE_ROW:
      config.YODA_BACKEND + "/order/api/v1/Orders/:orderId/rows/:rowId", // del
    CONFIRM_ORDER:
      config.YODA_BACKEND + "/order/api/v1/Orders/:orderId/ConfirmOrder", // put
    REMOVE_ORDER: config.YODA_BACKEND + "/order/api/v1/Orders/:id?soft=false", // del
    GET_ORDER_CONFIGURATIONS:
      config.YODA_BACKEND +
      "/order/api/v1/CommandAction/execute/B2BConfiguration?id=:customerId",
    GET_DETAILS:
      config.YODA_BACKEND +
      "/order/api/v1/CommandAction/execute/B2BOrderDetails2?id=:id",
    GET_ROW_DETAILS: config.YODA_BACKEND + "/order/api/v1/Orders/:id/rows/:row",
    SWITCH_TYPE:
      config.YODA_BACKEND +
      "/order/api/v1/CommandAction/execute/B2BChangeType?id=:id",
    GET_ALL_ADMIN_DRAFT:
      config.YODA_BACKEND +
      "/order/api/v1/CommandAction/execute/B2BOrderUserDeraft?page=:page&pageSize=:pageSize&Filters",
    WAITING_FOR_CONFIRMATION:
      config.YODA_BACKEND +
      "/order/api/v1/Orders/:id/WaitingForConfirmation?forceChangeStatusEvenIfTotalsHasChanged=true&preserveObsoletePrice=false",
    TRASMIT_ORDER:
      config.YODA_BACKEND +
      "/order/api/v1/CommandAction/Execute/B2B_TransmitOrder",
    REMOVE_PRODUCT:
      config.YODA_BACKEND +
      "/order/api/v1/CommandAction/execute/B2BOrderRowsDelete?orderid=:orderId&productid=:productId&rowTypeId=:rowTypeId&colorCode=:colorCode",
    GENERATE_REPORT:
      config.YODA_BACKEND +
      "/report/api/v1/ReportGenerator/reportName/HernoOrder/preview",
    CONCURRENT_UPDATE_ROW_SINGLE:
      config.YODA_BACKEND + "/order/api/v1/Orders/:id/rows/detail",
    CONCURRENT_UPDATE_ROW_AUTOCOMPLETE:
      config.YODA_BACKEND +
      "/order/api/v1/CommandAction/execute/B2BRowsAutocompile",
    GET_SHIPPING_COST:
      config.YODA_BACKEND +
      "/order/api/v1/CommandAction/execute/B2BOrderSingleDetail?id=:id&type=SHIPPINGCOST",
    GET_STATUS_SINGLE_ORDER:
      config.YODA_BACKEND +
      "/order/api/v1/CommandAction/execute/B2BOrderSingleDetail?id=:id&type=STATUS",
    CHANGE_LANGUAGE:
      config.YODA_BACKEND +
      "/order/api/v1/CommandAction/Execute/B2BChangeLanguage",
  },
  YODASTAKEHOLDER: {
    GET_ME:
      config.YODA_BACKEND +
      "/stakeholder/api/v1/CommandAction/execute/B2BRoles",
    GET_ORDER_HISTORY:
      config.YODA_BACKEND +
      "/stakeholder/api/v1/CommandAction/Execute/B2B_OrdersStatusHistory",
    GET_ORDER_HISTORY_NEW_COUNT:
      config.YODA_BACKEND +
      "/stakeholder/api/v1/CommandAction/Execute/B2B_HistoryNotificationsCount",
  },
  YODACUSTOMER: {
    GET_ALL:
      config.YODA_BACKEND +
      "/stakeholder/api/v1/CommandAction/execute/B2BCustomers?id=:agentId&page=:page&pageSize=:pageSize&Filters",
    GET_ONE:
      config.YODA_BACKEND +
      "/stakeholder/api/v1/CommandAction/execute/B2BCustomer?id=:customerId",
    GET_MESSAGES:
      config.YODA_BACKEND +
      "/stakeholder/api/v1/CommandAction/execute/B2BMessage?customerId=:id",
  },

  YODAIDENTITY: {
    GET_ONE:
      config.YODA_BACKEND +
      "/personalization/api/v1/genericModel/B2BRole?qp=uuid::uuid",
    GET_CUSTOMERS:
      config.YODA_BACKEND +
      "/stakeholder/api/v1/CommandAction/execute/B2BCustomers?id=:uuid&pageSize=10000&page=1&Filters",
    GET_DOORS:
      config.YODA_BACKEND +
      "/personalization/api/v1/genericModel/B2BDoor?qp=customerId::customerId&pageSize=10000",
    GET_ADDRESSES:
      config.YODA_BACKEND +
      "/personalization/api/v1/genericModel/B2BAddress?qp=customerId::customerId&pageSize=10000",
    GET_LINES:
      config.YODA_BACKEND +
      "/personalization/api/v1/genericModel/B2BLine?qp=customerId::customerId&pageSize=10000",
    GET_ORDER_CONFIGURATIONS:
      config.YODA_BACKEND +
      "/personalization/api/v1/genericModel/B2BOrder?qp=customerId::customerId&qp=agentId::agentId&pageSize=10000",
    GET_COLORS:
      config.YODA_BACKEND + "/catalog/api/v1/CommandAction/execute/B2BColor",
  },
  YODABUDGET: {
    GET_BUDGET:
      config.YODA_BACKEND +
      "/stakeholder/api/v1/CommandAction/execute/B2BBudget?customerId=:customerId&lineId=:lineId&seasonId=:seasonId",
  },
  YODAAGENT: {
    GET_ALL:
      config.YODA_BACKEND +
      "/stakeholder/api/v1/Agent?pageNumber=1&pageSize=10000",
    GET_ONE: config.YODA_BACKEND + "/stakeholder/api/v1/Agent/:agentId",
  },
  YODAINFO: {
    GET_COOKIE:
      config.YODA_BACKEND + "/personalization/api/v1/Contents/code/COOKIE",
    GET_PRIVACY:
      config.YODA_BACKEND + "/personalization/api/v1/Contents/code/PRIVACY",
    GET_SIZE_SCALE:
      config.YODA_BACKEND + "/personalization/api/v1/Contents/code/scalarino",
  },
};
